
<div class="gridheight mat-elevation-z8 viewport">
  
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
      <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button [matMenuTriggerFor]="menu"
              #menuTrigger="matMenuTrigger"
              (click)="loadMenuDataAndOpen(row, menuTrigger)">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              @if(controlPermissions.deletePriceMatrix){
                <button mat-menu-item (click)="onDeletePM(row.id)" style="color: red;">
                  <mat-icon matListIcon color="warn">delete</mat-icon>
                  <span matLine>Delete</span>
                </button>
              }
              <button mat-menu-item (click)="onOpenPM(row, 'Edit')">
                <mat-icon matListIcon>edit</mat-icon>
                <span matLine>Edit</span>
              </button>
              @if(controlPermissions.duplicatePriceMatrix){
                <button mat-menu-item (click)="onOpenPM(row, 'Duplicate')">
                  <mat-icon matListIcon>content_copy</mat-icon>
                  <span matLine>Duplicate</span>
                </button>
              }
              <button
                  mat-menu-item
                  (click)="openAttachDocuments(row.id)"
                >
                <mat-icon matListIcon>attach_file_add</mat-icon>
                <span matLine>Attach docs</span>
              </button>
              <button
                  mat-menu-item
                  [disabled]="row.loadSlip == false"
                  [ngClass]="{ iconBGColor: row.loadSlip == true }"
                  (click)="openViewDocsDialog(row.id)"
                >
                <mat-icon matListIcon>visibility</mat-icon>
                <span matLine>View docs</span>
              </button>
            </mat-menu>
          </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>

      <ng-container matColumnDef="tipFee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tip Fee </th>
        <td mat-cell *matCellDef="let element"> {{element.tipFee}} </td>
      </ng-container>

      <ng-container matColumnDef="tipFee_UOMV">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tip Fee Units </th>
        <td mat-cell *matCellDef="let element"> {{ element.tipFee_UOMV }} </td>
      </ng-container>

      <ng-container matColumnDef="disposalSiteNames">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Disposal Site(s) </th>
        <td mat-cell *matCellDef="let element"> {{element.disposalSiteNames}} </td>
      </ng-container>

      <!-- <ng-container matColumnDef="rental_Rate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Rental Rate </th>
        <td mat-cell *matCellDef="let element"> {{element.rental_Rate}} </td>
      </ng-container> -->

      <ng-container matColumnDef="haulRate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Haul Revenue </th>
        <td mat-cell *matCellDef="let element"> {{element.haulRate}} </td>
      </ng-container>

      <ng-container matColumnDef="monthly_Charges">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Monthly Charges </th>
        <td mat-cell *matCellDef="let element"> {{element.monthly_Charges}} </td>
      </ng-container>

      <ng-container matColumnDef="effective_StartDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Effective Start Date </th>
        <td mat-cell *matCellDef="let element"> {{element.effective_StartDate | date : 'MM/dd/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="effective_EndDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Effective End Date </th>
        <td mat-cell *matCellDef="let element"> {{element.effective_EndDate | date : 'MM/dd/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="rebate_UOMName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Rebarte UOM </th>
        <td mat-cell *matCellDef="let element"> {{element.rebate_UOMName}} </td>
      </ng-container>
      <ng-container matColumnDef="rebateValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Rebate Value </th>
        <td mat-cell *matCellDef="let element"> {{element.rebateValue}} </td>
      </ng-container>
      <ng-container matColumnDef="eis">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> EIS </th>
        <td mat-cell *matCellDef="let element"> {{element.eis}} </td>
      </ng-container>
      <ng-container matColumnDef="fuelSurcharge">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fuel Surcharge </th>
        <td mat-cell *matCellDef="let element"> {{element.fuelSurcharge}} </td>
      </ng-container>
      <ng-container matColumnDef="minimalCharges">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Min. Load Fee </th>
        <td mat-cell *matCellDef="let element"> {{element.minimalCharges}} </td>
      </ng-container>
      <ng-container matColumnDef="emergency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Emergency </th>
        <td mat-cell *matCellDef="let element"> {{element.emergency}} </td>
      </ng-container>
      <ng-container matColumnDef="noShow">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> No Show </th>
        <td mat-cell *matCellDef="let element"> {{element.noShow}} </td>
      </ng-container>
      <ng-container matColumnDef="financeFee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Partial Load To Yard </th>
        <td mat-cell *matCellDef="let element"> {{element.financeFee}} </td>
      </ng-container>
      <ng-container matColumnDef="selfHaulDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Self Haul </th>
        <td mat-cell *matCellDef="let element"> {{element.selfHaulDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="commissionEligibleDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Commission Eligible </th>
        <td mat-cell *matCellDef="let element"> {{element.commissionEligibleDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="haulFeePassThroughDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Haul Fee Pass Through </th>
        <td mat-cell *matCellDef="let element"> {{element.haulFeePassThroughDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="fuelSurchargePassThroughDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fuel Surcharge Pass Through </th>
        <td mat-cell *matCellDef="let element"> {{element.fuelSurchargePassThroughDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="invoiceNADescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice N/A </th>
        <td mat-cell *matCellDef="let element"> {{element.invoiceNADescription}} </td>
      </ng-container>
      <ng-container matColumnDef="incurEstimatedProcessingCostsDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Estimated Processing Costs </th>
        <td mat-cell *matCellDef="let element"> {{element.incurEstimatedProcessingCostsDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="isReviewedDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Reviewed </th>
        <td mat-cell *matCellDef="let element"> {{element.isReviewedDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="environmentalFee_LTL">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Environmental Fee LTL </th>
        <td mat-cell *matCellDef="let element"> {{element.environmentalFee_LTL}} </td>
      </ng-container>
      <ng-container matColumnDef="environmentalFee_FTL">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Environmental Fee FTL </th>
        <td mat-cell *matCellDef="let element"> {{element.environmentalFee_FTL}} </td>
      </ng-container>
      <ng-container matColumnDef="unloadingFee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Unload Fee </th>
        <td mat-cell *matCellDef="let element"> {{element.unloadingFee}} </td>
      </ng-container>
      <ng-container matColumnDef="binRentalFee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Bin Rental Fee </th>
        <td mat-cell *matCellDef="let element"> {{element.binRentalFee}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
            No data matching the filter.
          </td>
        </tr>
    </table>
</div>
